import { render, staticRenderFns } from "./_ResetPassword.vue?vue&type=template&id=79d50ae9&"
import script from "./_ResetPassword.vue?vue&type=script&lang=ts&"
export * from "./_ResetPassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports